<template>
  <div>
    <select class="ql-color"></select>
    <button class="ql-bold"></button>
    <button class="ql-italic"></button>
    <button class="ql-underline"></button>
    <!-- <button class="ql-emoji"></button>
    <button class="ql-link"></button> -->
    <button v-if="isListOrdered" class="ql-list" value="ordered"></button>
    <button v-if="isListbullet" class="ql-list" value="bullet"></button>
  </div>
</template>
<script>
export default {
  props: {
    isListOrdered: { type: Boolean, default: false },
    isListbullet: { type: Boolean, default: false },
  },
};
</script>
